import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of, Subject } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { LandingService } from '../../landing/landing.service';

@Component({
  selector: 'newsletter-landing-page',
  templateUrl: './newsletter-landing-page.component.html',
  styleUrls: ['./newsletter-landing-page.component.scss']
})
export class NewsletterLandingPageComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<boolean> = new Subject();
  public isLoaded = false;
  public content;

  private topLogoFolder = 'https://cdn.otosrl.com/images/touroperator/mini/';
  public topLogo = null;

  public network;

  constructor(
    private _landingService: LandingService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const segments = this._route.snapshot['_urlSegment'].segments.map(x => x.path);
    const queryParams = this._route.snapshot.queryParams;
    const contentId = Number(segments[segments.length - 1]);

    const isFromSocialTool = queryParams.isSocialCard !== undefined;
    this.network = queryParams.network;


    if (!isFromSocialTool) {
      this._landingService.getCustomContent(contentId).then(
        (response) => {
          if (!response) {
          } else {
            this.content = response;
            if (this.content.Testo) {
              this.content.Testo = this.content.Testo.replace(/\n/g, '<br/>');
            }
            if (this.content?.Top?.id && this.content?.Top?.id != -1) {
              this.topLogo = `${this.topLogoFolder}${this.content.Top.id}-${this.content.Top.id}.png`;
            } else if (this.content?.Top?.name) {
              this.topLogo = this.content.Top?.name;
            }

          }
          this.isLoaded = true;

        },
        (error) => {
        }
      );
    } else {
      this._landingService.getSocialCardById(contentId).pipe(
        takeUntil(this._destroy$),
        map(card => {
          const productData = JSON.parse(JSON.parse(card.productData).data);
          const obj = {
            Testo: productData.description,
            Titolo: productData.title,
            UrlImg: productData.image,
          };
          const top = productData.top;
          if (top) {
            this.topLogo =  `${this.topLogoFolder}${top}-${top}.png`;
          }
          return obj;
        }),
        catchError(e => {
          console.error("ERROR CMS API", e);
          return of(null)
        })
      ).subscribe(x => {
        this.content = x;
        this.isLoaded = true;
      });

    }
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
  }


}
